/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReceiptRequest } from '../../models/receipt-request';
import { ReceiptRequestApiRespModel } from '../../models/receipt-request-api-resp-model';

export interface ApiRequestReceiptSaveSubmitPost$Params {
      body?: ReceiptRequest
}

export function apiRequestReceiptSaveSubmitPost(http: HttpClient, rootUrl: string, params?: ApiRequestReceiptSaveSubmitPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptRequestApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiRequestReceiptSaveSubmitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReceiptRequestApiRespModel>;
    })
  );
}

apiRequestReceiptSaveSubmitPost.PATH = '/api/Request/Receipt/SaveSubmit';
